import {AggregatedDataPoint} from "@flowmaps-com/flowmaps-typescriptmodels";
import moment from "moment";

type PhysicalDataPoint = Pick<AggregatedDataPoint, "timeRange"> & Partial<Pick<AggregatedDataPoint, "value">> & {utcOffsetSeconds?: number; durationSeconds?: number};

/** Old responses retain their local-time fallback during a rolling release. */
export function measurementStart(point: PhysicalDataPoint): string {
    const physical = point as PhysicalDataPoint;
    return physical.utcOffsetSeconds == null ? point.timeRange?.start
        : moment.utc(point.timeRange.start).subtract(physical.utcOffsetSeconds, "seconds").toISOString();
}

export function measurementEnd(point: PhysicalDataPoint): string {
    const physical = point as PhysicalDataPoint;
    if (physical.utcOffsetSeconds == null) return point.timeRange?.end;
    const duration = physical.durationSeconds ?? moment.utc(point.timeRange.end).diff(moment.utc(point.timeRange.start), "seconds");
    return moment.utc(measurementStart(point)).add(duration, "seconds").toISOString();
}

export function measurementIdentity(point: PhysicalDataPoint): string {
    return measurementStart(point) + "|" + measurementEnd(point);
}

/** Report labels retain local display while making the physical offset explicit. */
export function measurementStartLabel(point: PhysicalDataPoint, format: string): string {
    const physical = point as PhysicalDataPoint;
    return moment(measurementStart(point)).format(physical.utcOffsetSeconds == null ? format : format + " Z");
}